
import axios from 'axios';
import PhotoContract from '../contracts/Photo';
import Resource from './Resource';

/**
 * Photo class
 * @class
 **/
class Photo extends Resource implements PhotoContract
{
    /**
     * Resource identifier
     * @type {String}
     **/
    static handle = 'photo_id';

    /**
     * Default attributes
     * @type {Object}
     **/
    static attributes: PhotoContract = {
        photo_id: undefined,
        source: undefined,
        width: undefined,
        height: undefined,
        taken_at: undefined,
    };

    /**
     * Resource attributes
     * @type {Object}
     **/
    attributes: PhotoContract;

    /**
     * Current attributes
     **/
    readonly photo_id: number;
    readonly source: string;
    readonly width: number;
    readonly height: number;
    readonly taken_at: string;

    /**
     * Get photo ratio
     * @returns {Number}
     */
    get ratio(): number
    {
        return this.width / this.height;
    }


    /**
     * Delete photo
     */
    destroy()
    {
        return this.delete();
    }


    /**
     * Delete photo
     * @return {Promise}
     */
    delete()
    {
        return axios.delete( `/api/shoot/photo/${ this.photo_id }` );
    }
}

Resource.register( Photo );

export default Photo;
